// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_MAIN_FEATURE_MAXIMUM_LOAD_PER_CHILD_IN_kg = "Nosnost %(kg)s kg (d\u00edt\u011b)";
export const STROLLER_MAIN_FEATURES = "Hlavn\u00ed parametry";
export const STROLLER_MAIN_FEATURE_STROLLER_FOR_PARENT_BY_HEIGHT_TALL = "Pro vysok\u00e9 rodi\u010de";
export const STROLLER_MAIN_FEATURE_UNFOLDED_DIMENSIONS_IN_cm_WIDTH = "\u0160\u00ed\u0159ka do v\u00fdtahu %(cm)s cm";
export const STROLLER_MAIN_FEATURE_WEIGHT_IN_kg = "Hmotnost %(kg)s kg";
export const STROLLER_SEARCH_FORM_VERY_GOOD_FOLDING = "Velmi dob\u0159e skladn\u00fd";
export const STROLLER_TYPE_CHECKED_BAGGAGE = "Cestovn\u00ed";
export const STROLLER_TYPE_CITY_TERRAIN = "M\u011bstsk\u00fd";
export const STROLLER_TYPE_COUNTRYSIDE_TERRAIN = "Vesnice";
export const STROLLER_TYPE_HARD_TERRAIN = "Ter\u00e9nn\u00ed";
export const STROLLER_TYPE_SPORT_RUNNING = "B\u011bh a sport";
